import React, { useEffect, useState } from "react";
import { useGameController } from "../hooks/useGameController.ts";
import '../assets/css/inventory-gui.css';

export default function ShopGUI(){
    const [currentInventory, setCurrentInventory] = useState([]);
    const [currentInventoryIndex, setCurrentInventoryIndex] = useState(null);
    const gameController = useGameController();

    useEffect(() => {
        const handler = (event, newGameState) => {
            setCurrentInventory(Object.values(gameController.player.inventory));
            setCurrentInventoryIndex(gameController.player.inventoryCurrentIndex);
        };
        gameController.addEventHandler(["inventory:updated"], 'inventory-gui', handler);
        return () => {
            gameController.removeEventHandler(["inventory:updated"], 'inventory-gui', handler);
        }
    }, []);

    function use(item: {key: string, price: number, sceneState?: string}){
        gameController.player.use(item);
    }
    return(
       <>
        <div  style={{position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', left: 0, right: 0, bottom: 20, backgroundColor: 'transparent'}}>
        
            <div className={'inventory'}>
                <div className="inventory-items">
                    {currentInventory.map((item, index) => (
                        <button key={index} className={`inventory-item ${index == currentInventoryIndex ? 'current' : ''}`} onClick={()=>use(item)}>
                            <div className="item-icon" style={{backgroundImage: 'url('+item.icon+')'}}></div>
                            <span className="item-name">{item.name}</span>
                            <span className="item-quantity">{1}</span>
                        </button>
                    ))}
                    {currentInventory.length < 4 && new Array(4 - currentInventory.length).fill(undefined).map((item, index) => (
                        <button key={index} className="inventory-item">
                            <div className="item-icon" ></div>
                            <span className="item-name"></span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    </>);
        
}